// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"dc6c850e","480":"bca69b57"}[chunkId] + ".js";
};